<template>
  <div class="grid-x grid-padding-x align-middle contentContainer">
    <div class="cell small-12 contentPosition">
      <h1>We started out tiny. Now we’re the best in the world at what we do.</h1>
    </div>
  </div>

</template>

<script>

export default {
  name: 'RareStoriesHeaderContents',
};
</script>

<style scoped>

  .contentContainer {
    height: 100%;
  }

  h1 {
    color: #ffffff;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    text-align: left;
  }

  @media only screen and (max-width: 640px)  {
    .contentPosition {
      padding-left: 6%;
    }

    .contactButton {
      margin-top: 10px;
    }

    h1 {
      font-size: 32px;
      line-height: 1.25;
    }
  }

  @media only screen and (min-width: 641px) and (max-width: 1049px)  {
    .contentPosition {
      padding: 0 9% 0 9%;
    }

  }

  @media only screen and (min-width: 1050px)  {
    .contentPosition {
      padding: 0 25% 0 13%;
    }

    h1 {
      font-size: 64px;
      line-height: 1.25;
    }
  }


</style>



// WEBPACK FOOTER //
// src/pages/about/components/RareAboutHeaderContents.vue